import { render } from "./UnsubscribedComponent.vue?vue&type=template&id=7f91e782&scoped=true"
import script from "./UnsubscribedComponent.vue?vue&type=script&lang=js"
export * from "./UnsubscribedComponent.vue?vue&type=script&lang=js"

import "./UnsubscribedComponent.vue?vue&type=style&index=0&id=7f91e782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f91e782"]])

export default __exports__